import cn from 'classnames';
import { Link } from 'react-router-dom';
import React, { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';
import { FaBell as Bell, FaCaretDown as Down } from 'react-icons/fa';
import { useProfile } from 'modules/auth/hooks';
import ThumbIcon from './ThumbIcon';

const userNavigation = [{ name: 'Logout', href: '/logout' }];

function HeaderProfile() {
  const [profile] = useProfile();
  const name = `${profile?.profile?.first_name} ${profile?.profile?.last_name}`;
  const role = profile?.role?.name;
  const email = profile?.email;
  return (
    <div className="relative flex items-center">
      <ThumbIcon className="h-8 w-8 rounded-full" alt={name} />
      <div className="font-[400] text-gray-600 ml-3">
        <div className="text-sm">{name}</div>
        <div className="text-xs">{role}</div>
      </div>
      <div className="flex ml-10 space-x-3">
        <Bell className="text-primary" />
        <Menu as="div" className="relative">
          {({ open }) => (
            <>
              <div>
                <Menu.Button className="max-w-xs bg-white flex items-center text-sm rounded-full focus:outline-none">
                  <span className="sr-only">Open user menu</span>
                  <Down className="text-primary" />
                </Menu.Button>
              </div>
              <Transition
                as={Fragment}
                enter="transition ease-out duration-100"
                enterFrom="transform opacity-0 scale-95"
                enterTo="transform opacity-100 scale-100"
                leave="transition ease-in duration-75"
                leaveFrom="transform opacity-100 scale-100"
                leaveTo="transform opacity-0 scale-95"
                show={open}
              >
                <Menu.Items className="origin-top-right absolute right-0 mt-2 w-64 rounded-md shadow-primary-xl bg-white ring-1 ring-black ring-opacity-5 focus:outline-none pb-4 pt-2 z-50">
                  <div className="flex px-3 py-2 space-x-2 border-b border-gray-100 text-gray-500">
                    Signed in as
                  </div>
                  <div className="flex px-3 py-2 space-x-2 border-b border-gray-100 items-center">
                    <ThumbIcon className="h-12 w-12 rounded-full" alt={name} />
                    <div>
                      <div className="">{name}</div>
                      <div className="text-sm text-gray-500">{email}</div>
                    </div>
                  </div>
                  {userNavigation.map((item) => (
                    <Menu.Item key={item.name}>
                      {({ active }) => (
                        <Link
                          to={item.href}
                          className={cn(
                            active ? 'bg-gray-100' : '',
                            'block px-4 py-2 text-sm text-gray-700',
                          )}
                        >
                          {item.name}
                        </Link>
                      )}
                    </Menu.Item>
                  ))}
                </Menu.Items>
              </Transition>
            </>
          )}
        </Menu>
      </div>
    </div>
  );
}

HeaderProfile.propTypes = {};

export default HeaderProfile;
